module.exports = __webpack_public_path__ + "img/menu@2x.fcd773a1.jpg";